import React, { Component } from 'react';
import ScrollBooster from './ScrollBooster';

import map from 'lodash/map';
import max from 'lodash/max';
import size from 'lodash/size';
import indexOf from 'lodash/indexOf';
import isArray from 'lodash/isArray';
import uniq from 'lodash/uniq';

import classNames from 'classnames';
import getContrastYIQ from '../../utils/getContrastYIQ';


const COLORS = uniq([
  "#000000",
  "#262626",
  "#424242",
  "#595959",
  "#757071",
  "#9B9B9B",
  "#B6B6B6",
  "#BFBDB9",
  "#D1D1D1",
  "#DEDEE0",
  "#E7E7E7",
  "#FFFFFF",
  "#1E2A78","#FF2E4C","#FFE720","#49DEB2",
  "#6F5F5E","#FEC397","#D28A7C","#6D8C8E",
  "#FF4747","#00BCB4","#C4E86B","#FFB547",
  "#B68FA2","#586F77","#ACBCB1","#333B3E",
  "#8B776D","#463C52","#9D94BA","#D1D5E8",
  "#FFCEBE","#CD2C6C","#5F023A","#108292",
  "#7EC384","#3F8756","#45625D","#6AA5A9",
  "#FEF3E2","#EDCFC0","#C3D3D6","#D5DBE4",
  "#514945","#894243","#D55C5A","#EBD4CC",
  "#ECEBEB","#E6E5E5","#D5D0D2","#C5BEC4",
  "#FFEF38","#F7A41A","#275C7A","#001446",
  "#99ABB9","#B37B56","#3D455C","#60402B",
  "#AB0068","#E00702","#FF6C02","#FEC106",
  "#DEA450","#9B461F","#6A1D2F","#354C3C",
  "#001B48","#02457A","#018ABE","#97CADB",
  "#CCABD8","#8474A1","#6EC6CA","#08979D","#055B5C",
  "#86E3CE","#D0E6A5","#FFDD94","#FA897B","#CCABD8",
  "#D9ECF2","#F56A79","#FF414D","#1AA6B7","#002D40",
  "#54C0CC","#1F4F59","#7EA00E","#DCD964","#213502",
  "#E25B45","#FF8357","#FAC172","#89D5C9","#ADC865",
  "#F5CEC7","#E79796","#FFC98B","#FFB284","#C6C09C",
  "#E2474B","#2F3A56","#406D96","#A8D0DA","#D8E8E8",
  "#AAC9CE","#B6B4C2","#C9BBC8","#E5C1CD","#F3DBCF",
  "#FCF5EF","#FEA735","#FE7235","#00C3FF","#0077FF",
  "#80BEAF","#B3DDD1","#D1DCE2","#F5B994","#EE9C6C",
  "#272537","#606977","#D1DCE2","#E5D817","#E3BF76",
  "#D2A9B0","#E1C0D8","#F1CFE5","#A9A5A2","#C8C6C9",
  "#FFFFFF","#E7E7E7","#D1D1D1","#B6B6B6","#9B9B9B",
  "#513485","#7E5AB8","#D79CD2","#FDD51E","#758B5C",
  "#999999","#555555","#FB6602","#F6A705","#AF948F",
  "#235D3A","#397D54","#73C088","#A8E0B7","#C8EAD1",
  "#478BA2","#DE5B6D","#E9765B","#F2A490","#B9D4DB",
  "#751102","#A72F1D","#C55241","#E07464","#F59E91",
  "#455054","#308695","#D45769","#E69D45","#D4CFC9",
  "#1B2727","#3C5148","#6B8E4E","#B2C5B2","#D5DDDF",
  "#321E25","#663845","#8B4E5E","#C06378","#E894A7",
  "#07585C","#3E9022","#DE076F","#491545","#491515",
  "#5D0D02","#A61804","#FC0000","#FF4646","#FF7A7A",
  "#5D7599","#ABB6C8","#DADADA","#F7F0C6","#C2C4B6",
  "#7E9680","#79616F","#AE6378","#D87F81","#EAB595","#EAD7BA","#5D7599","#ABB6C8","#9FCAA3","#E78764","#AE6378","#E1D839"
]);


const Color = ({color, selected, onClick}) => (<li className={classNames({selected: !!selected})} style={{backgroundColor: color}} onClick={onClick} />)

const isValidColor = (color) => /^#[0-9A-F]{6}$/i.test(color)


const ITEM_WIDTH = 48;

class ColorPicker extends Component {
  
  constructor (props){
    super(props);
    
    this.onUpdate = this.onUpdate.bind(this);
    this.onUpdateEnd = this.onUpdateEnd.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCustomChange = this.onCustomChange.bind(this);
    this.setCustom = this.setCustom.bind(this);
    
    this.selectorPosition = 2
    this.colors = this.props.colors || COLORS;
    
    this.customInput = null;
    this.setCustomInputRef = element => {
      this.customInput = element;
    };
    
    
    let { value, itemWidth } = this.props;
    const x = this.getSelectedX()
    
    if (isArray(value))
      value = value[0];
    
    this.state = {
      x: x,
      selected: value,
      custom: value && indexOf(this.colors, value) < 0,
      customColor: indexOf(this.colors, value) < 0 ? value : null,
      position: {x: x},
      itemWidth: (itemWidth || ITEM_WIDTH)
    }
  }
  
  componentWillReceiveProps (nextProps) {
    if (nextProps.colors !== this.props.colors)
      this.colors = nextProps.colors || COLORS
    
    if (nextProps.value !== this.props.value && isValidColor(nextProps.value)){
      const isCustom = indexOf(this.colors, nextProps.value) < 0;
      // this.setState({selected: nextProps.value, custom: isCustom});
      this.onChange(nextProps.value, isCustom, true)
      if (isCustom)
        this.setState({customColor: nextProps.value})
    }
  }
  
  
  onUpdate (data) {
    let x = data.position.x;
    const { discrette } = this.props;
    const width = this.state.itemWidth;
    
    if (discrette)
      x = x - (x % width)
    
    this.setState({x: Math.ceil(x)});
  }
  
  onUpdateEnd (){
    const { onChange, discrette } = this.props;
    const { x, itemWidth, customColor } = this.state;
    if (discrette === true) {
      const idx = Math.ceil(x / itemWidth);
      let color = this.colors[idx];
      if (!color)
        color = customColor;
      
      this.setState({selected: color});
      onChange && onChange(color);
    }
  }
  
  onChange (color, is_custom, skipChange){
    const { onChange, discrette } = this.props;
    const isCustom = is_custom === true || indexOf(this.colors, color) < 0;
    this.setState({selected: color, custom: isCustom});
    !skipChange && onChange && onChange(color);
    
    if (discrette){
      setTimeout(()=> {
        const currX = this.getSelectedX();
        this.setState({x: currX, position: {x: currX}});
      }, 0);
    }
  }
  
  onCustomChange(){
    const value = '#' + (this.customInput.value || '').replace(/[^0-9A-F]/gi, '').toUpperCase().substring(0, 6)
    this.setState({customColor: value});
    
    //const value = '#' + (this.customInput.value || '').replace('#', '');
    if (!isValidColor(value))
      return
    this.onChange(value, true);
  }
  
  setCustom (color){
    const { selected, customColor } = this.state;
    this.onChange(color || customColor || selected, true);
    this.customInput && this.customInput.focus();
  }
  
  
  getSelectedIdx (){
    const state = (this.state || {})
    const selected = state.selected || this.props.value;
    let idx = indexOf(this.colors, selected);
    if (state.custom === true || (idx < 0 && selected && state.customColor))
      idx = size(this.colors)
    return idx;
  }
  
  getSelectedX (){
    const { discrette } = this.props;
    const state = (this.state || {});
    let idx = this.getSelectedIdx();
    if (idx < 0)
      idx = size(this.colors);
    const selectorPosition = discrette === true ? 0 : this.selectorPosition;
    const width = state.itemWidth || ITEM_WIDTH;
    
    return max([(idx * width) - selectorPosition * width, 0]);
  }
  
  render () {
    const { discrette } = this.props;
    const x = this.state.x || 0
    const { customColor } = this.state;
    
    return (<ScrollBooster x={x} friction={0.1} position={this.state.position} className={classNames({"colorpicker": true, discrette})} mode="x" emulateScroll={true} bounce={!discrette} onUpdate={this.onUpdate} onUpdateEnd={this.onUpdateEnd}>
      <ul style={{transform: `translateX(${-x}px)`}}>
        {map(this.colors, (color, i)=> <Color key={i} color={color} selected={color === this.state.selected && !this.state.custom} onClick={()=> this.onChange(color)} />)}
        
        <li className={classNames({'color-field': true, selected: this.state.custom})} onClick={() => this.setCustom()}>
          <input type="text" placeholder="Hex Color" value={(customColor || '').replace('#', '')} ref={this.setCustomInputRef} onChange={this.onCustomChange} />
          <span className="color-hex" style={isValidColor(customColor) ? {backgroundColor: customColor, color: getContrastYIQ(customColor)} : {}}>#</span>
        </li>
        
      </ul>
    </ScrollBooster>)
  }
};

export default ColorPicker;


// WEBPACK FOOTER //
// ./src/components/helpers/ColorPicker.js